import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=1b25bf56&scoped=true&"
import script from "./Sponsor.vue?vue&type=script&lang=js&"
export * from "./Sponsor.vue?vue&type=script&lang=js&"
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=1b25bf56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b25bf56",
  null
  
)

export default component.exports